import { render, staticRenderFns } from "./TravelMap.vue?vue&type=template&id=2bae3fb6&scoped=true&"
import script from "./TravelMap.vue?vue&type=script&lang=js&"
export * from "./TravelMap.vue?vue&type=script&lang=js&"
import style0 from "./TravelMap.vue?vue&type=style&index=0&id=2bae3fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae3fb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
